























import { Component, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import TagSelect from '@/components/TagSelect.vue';
import FormBase from '@/mixins/FormBase';
import { Action, Getter } from 'vuex-class';
import FarmGroup from '@/core/interfaces/FarmGroup';
import Farm from '@/core/interfaces/Farm';

@Component({
    components: { FormFooter, TagSelect },
})
export default class FarmGroupForm extends FormBase<FarmGroup> {
    @Action('saveFarmGroup')
    saveAction!: (farmGroup: Partial<FarmGroup>) => Promise<FarmGroup>;

    @Getter('farms')
    farms!: Farm[];

    name = '';

    farmIds: number[] = [];

    @Watch('initial', { immediate: true })
    async setFromInitial(): Promise<void> {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';

        this.farmIds = [...(this.initial.farm_ids || [])];
    }

    get parseForm(): Partial<FarmGroup> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
            farm_ids: this.farmIds,
        };
    }
}

